import { render, staticRenderFns } from "./FeedbackPreference.vue?vue&type=template&id=6499967b&scoped=true&"
import script from "./FeedbackPreference.vue?vue&type=script&lang=js&"
export * from "./FeedbackPreference.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackPreference.vue?vue&type=style&index=0&id=6499967b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6499967b",
  null
  
)

component.options.__file = "FeedbackPreference.vue"
export default component.exports